import { atom } from 'recoil';

export const dataCommerceBeneFinalProcess = atom({
  key: 'dataCommerceBeneFinalProcess',
  default: undefined,
});
